import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface PromoCodeStyles {
  container: Styles
  promoCodeContainer: Styles
  promoCodeButton: Styles
  promoCodeText: Styles
  activeContainer: Styles
  promoCodeTextFieldContainer: Styles
  promoCodeTextField: Styles
  promoCodeTextFieldClear: Styles
  promoCodeApplyButton: Styles
  errorContainer: Styles
  errorText: Styles
  successText: Styles
  promoCodeApplicabilityContainer: Styles
  promoCodeApplicability: Styles
  verifyButton: Styles
}

interface PromoCodeStylesProps {
  isCouponValid: boolean
  isActive: boolean
  isDiscountApplied: boolean
  promoCode: string
}

export const useStyles = createUseStyles<PromoCodeStyles, PromoCodeStylesProps>((theme) => {
  return {
    container: {
      marginTop: theme.calcUnit(theme.spacing.s3),
    },
    promoCodeContainer: {
      display: 'flex',
    },
    promoCodeButton: ({ isActive }) => ({
      display: 'flex',
      justifyContent: 'space-between',
      padding: '13.5px 12px',
      borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
      borderBottomLeftRadius: isActive ? 0 : theme.calcUnit(theme.borderRadius.roundedDefault),
      borderBottomRightRadius: isActive ? 0 : theme.calcUnit(theme.borderRadius.roundedDefault),
      width: '100%',
      cursor: 'pointer',
      color: theme.colors.webLinkText,
      backgroundColor: theme.colors.webFadedBackground,
    }),
    promoCodeText: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: theme.calcUnit(14),
      fontWeight: '500',
      alignSelf: 'center',
    },
    activeContainer: ({ isActive }) => ({
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.colors.webFadedBackground,
      borderBottomLeftRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
      borderBottomRightRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
      padding: '0px 12px 13.5px 12px',
      opacity: isActive ? 1 : 0,
      height: isActive ? 'auto' : 0,
      transition: isActive ? 'opacity 0.3s ease-in' : 'opacity 0.3s ease-out',
      visibility: isActive ? 'visible' : 'hidden',
    }),
    promoCodeTextFieldContainer: {
      position: 'relative',
      flex: 1,
    },
    promoCodeTextField: {
      width: '100%',
      borderTop: '1px solid',
      borderBottom: '1px solid',
      borderLeft: '1px solid',
      borderColor: ({ isCouponValid }) => (isCouponValid ? theme.colors.webTextFieldBorder : '#FC1D1D'),
      fontSize: theme.calcUnit(14),
      borderTopLeftRadius: theme.calcUnit(theme.borderRadius.roundedSm),
      borderBottomLeftRadius: theme.calcUnit(theme.borderRadius.roundedSm),
      borderTopRightRadius: theme.calcUnit(0),
      borderBottomRightRadius: theme.calcUnit(0),
      paddingTop: theme.calcUnit(10),
      paddingBottom: theme.calcUnit(10),
      paddingLeft: theme.calcUnit(10),
      paddingRight: theme.calcUnit(60),
      '&:focus': {
        outline: 'none',
      },
    },
    promoCodeTextFieldClear: {
      position: 'absolute',
      right: theme.calcUnit(16),
      top: '50%',
      transform: 'translate(0, -50%)',
      cursor: 'pointer',
      color: theme.colors.webFadedTextColor,
      fontWeight: '400',
      fontSize: theme.calcUnit(14),
      lineHeight: theme.calcUnit(16),
      fontFamily: 'Roboto, sans-serif',
    },
    promoCodeApplyButton: ({ isDiscountApplied, promoCode }) => ({
      backgroundColor:
        isDiscountApplied || promoCode === ''
          ? theme.colors.webTextFieldBorder
          : theme.colors.couponAppliedBackgroundColor,
      border: '0.2px solid ',
      borderColor: isDiscountApplied || promoCode === '' ? theme.colors.webTextFieldBorder : theme.colors.borderColor,
      color: theme.colors.webInverseTextColor,
      padding: theme.calcUnit(10),
      fontSize: theme.calcUnit(14),
      borderTopRightRadius: theme.calcUnit(theme.borderRadius.roundedSm),
      borderBottomRightRadius: theme.calcUnit(theme.borderRadius.roundedSm),
      cursor: isDiscountApplied || promoCode === '' ? 'default' : 'pointer',
    }),
    errorContainer: {
      display: 'flex',
      marginTop: theme.calcUnit(theme.spacing.s1),
    },
    errorText: {
      color: '#FC1D1D',
      fontWeight: '400',
      fontStyle: 'italic',
      fontSize: theme.calcUnit(12),
      fontFamily: 'Roboto, sans-serif',
      marginLeft: theme.calcUnit(theme.spacing.s1),
    },
    successText: {
      color: theme.colors.validPasswordColor,
      fontWeight: '400',
      fontStyle: 'italic',
      fontSize: theme.calcUnit(12),
      fontFamily: 'Roboto, sans-serif',
      marginLeft: theme.calcUnit(theme.spacing.s1),
    },
    promoCodeApplicabilityContainer: {
      display: 'flex',
      marginTop: theme.calcUnit(10),
      justifyContent: 'space-between',
    },
    promoCodeApplicability: {
      display: 'flex',
      color: theme.colors.webFadedTextColor,
      fontWeight: '400',
      fontSize: theme.calcUnit(10),
      lineHeight: theme.calcUnit(12),
    },
    verifyButton: {
      cursor: 'pointer',
    },
  }
})
